import React from "react";
// import banner from "../../assets/projects/leadflowbanner.jpg";
import ss1 from "../../assets/screenshots/dailyjirasummarizer/ss1.png";
import ss2 from "../../assets/screenshots/dailyjirasummarizer/ss2.png";
import banner from "../../assets/projects/dailyticketsummaries.png";
const DailyJiraSummarizerPage = () => (
  <main className="container mx-auto max-width pt-10 pb-20 space-y-16">
    {/* Banner Image */}
    <section className="w-full">
      <img
        src={banner}
        alt="Daily Jira Ticket Summarizer Banner"
        className="w-[500px] rounded-xl shadow-md object-cover"
      />
    </section>

    {/* Project Title & Overview */}
    <section>
      <h1 className="text-4xl xl:text-5xl font-bold text-dark-heading dark:text-light-heading mb-4">
        Automating Daily Ticket Summaries with AI
      </h1>
      <p className="text-lg text-content lg:max-w-4xl">
      The client was overwhelmed by the constant need to stay updated on daily Jira tickets without having to read through every thread or log into the system manually. They wanted a simple way to keep track of ongoing support issues and engineering updates without wasting hours each day. I built the Daily Jira Ticket Summarizer, an AI-powered automation using n8n, Jira Software, and ChatGPT API. It collects newly created or updated tickets, gathers all related comments, summarizes the entire context using ChatGPT, and delivers a clean daily email digest directly to the client’s inbox, saving them time while keeping them fully informed.
</p>



    </section>

    {/* Technology Stack */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        💻 Technology Stack
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
      <li><strong>n8n:</strong> Handles all automation workflows.</li>
<li><strong>Jira Software:</strong> Source of tickets and comments via the Jira REST API.</li>
<li><strong>ChatGPT (OpenAI):</strong> Used to summarize ticket content and comment history into human-friendly formats.</li>
<li><strong>JavaScript:</strong> Used for formatting the email body.</li>

      </ul>
    </section>

    {/* n8n Workflows */}
    <section>
  <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
    🔄 n8n Automation Workflows
  </h2>
  <ul className="list-disc list-inside text-content space-y-2">
    <li><strong>Fetch Jira Tickets:</strong> Automatically get all tickets created today.</li>
    <li><strong>Extract Ticket Data:</strong> Collect ticket details and associated comments.</li>
    <li><strong>Summarize with AI:</strong> Use ChatGPT to generate clear, concise ticket summaries.</li>
    <li><strong>Email Delivery:</strong> Compile and send all summaries in a single daily email.</li>
  </ul>
</section>


    {/* Screenshots */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        🖼️ Project Images & Screenshots
      </h2>
      <div>
        <p className="mb-2 font-medium">Key Features</p>
        <a href={banner} target="_blank" rel="noopener noreferrer">
          <img src={banner} alt="Customer Feedback Workflow" className="w-full rounded-lg shadow" />
        </a>
      </div>
      <div className="flex flex-col gap-6">
        <div>
          <p className="mb-2 font-medium">Daily Jira Ticket Summarizer Workflow (n8n)</p>
          <a href={ss1} target="_blank" rel="noopener noreferrer">
            <img src={ss1} alt="Daily Jira Ticket Summarizer Workflow (n8n)" className="w-full rounded-lg shadow" />
          </a>
        </div>
        <div>
          <p className="mb-2 font-medium">Daily Summary Email</p>
          <a href={ss2} target="_blank" rel="noopener noreferrer">
            <img src={ss2} alt="Daily Summary Email" className="w-full rounded-lg shadow" />
          </a>
        </div>
       
      </div>
    </section>
  </main>
);

export default DailyJiraSummarizerPage;
